// @flow
import * as React from 'react';
import { TagsView } from '../../../shared';
import { TagsFormButton } from '../../../features/tags-form';
import { Chip } from '@mui/material';
import { AssignedTagViewOutput } from '@coverright/data-access/types/enrollment';
import { useClient } from '../hooks/client-context';

type Props = {
  clientId: string;
  tags?: AssignedTagViewOutput[];
};

export const ClientTags = (props: Props) => {
  const {tags} = props;
  return <TagsFormButton {...props}>
    {tags && tags.length ? <TagsView tags={tags} /> :
      <Chip variant="outlined" label={'No tags added'} size={'small'} sx={{border: '1px dashed #b9b9b9', '& *': {color: '#b9b9b9'} }} />}
  </TagsFormButton>
}
